import fetch from "../fetch";

export default ({ userName }) =>
  fetch({
    method: "DELETE",
    path: `/accounts/${userName}`
  });
